import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import classNames from "classnames";
// import Icon from "../../../components/Library/Icon/Icon";
import * as userSettingsActions from "../../actions/userSettings";

import DeleteAccount from "./DeleteAccount";
import ChangePassword from "./ChangePassword";
import toggleScroll from "../../../utils/toggleScroll";

import styles from "./UserSettings.css";

class ProfileSettings extends Component {
  constructor() {
    super();

    this.state = {
      showDeleteAccount: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.toggleDeleteAccount = this.toggleDeleteAccount.bind(this);
    this.toggleChangePassword = this.toggleChangePassword.bind(this);
  }

  handleChange(event) {
    this
      .props
      .userSettingsActions
      .typingUserSettings({
        [event.target.name]: event.target.value,
      });
  }

  handleSubmit() {
    this
      .props
      .userSettingsActions
      .submitUserSettings(this.props.userSettings.data.profileInfo);
  }

  toggleDeleteAccount() {
    toggleScroll();
    this.setState({ showDeleteAccount: !this.state.showDeleteAccount });
  }

  toggleChangePassword() {
    toggleScroll();
    this.setState({ showChangePassword: !this.state.showChangePassword });
  }

  render() {
    return (
      <div className={styles.infoWrapper}>
        {this.state.showDeleteAccount ?
          <DeleteAccount toggleDeleteAccount={this.toggleDeleteAccount} />
          : null}

        {this.state.showChangePassword ?
          <ChangePassword toggleChangePassword={this.toggleChangePassword} />
          : null}

        <div className={styles.blueHeading}>
          PROFILE
        </div>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>FIRST NAME</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="First name" onChange={this.handleChange} name="first_name" type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.first_name} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>LAST NAME</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Last Name" onChange={this.handleChange} name="last_name" type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.last_name} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>EMAIL</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Email" onChange={this.handleChange} name="email" type="email" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.email} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>JOB TITLE</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Job Title" onChange={this.handleChange} name="job_title" type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.job_title} />
          </Col>
        </Row>

        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>INDUSTRY</Col>
          <Col lg="10" sm="12" xs="12">
            <input aria-label="Industry" onChange={this.handleChange} name="industry" type="text" className={styles.bottomLineInputs} value={this.props.userSettings.data.profileInfo.industry} />
          </Col>
        </Row>

        { /*
        <Row className={styles.marginTop20}>
          <Col lg="2" sm="12" xs="12" className={styles.muted}>PHOTO</Col>
          <Col lg="10" sm="12" xs="12">
            <div className={styles.avatar}>
              {
                this.props.userSettings.data.avatar_url ?
                  <img src={this.props.userSettings.data.avatar_url} alt="Profile picture" /> :
                  <Icon name="avatar" path="img" description="Avatar Placeholder" className={styles.avatar}/>
              }

              {
                this.props.userSettings.data.avatar_url ?
                  <Icon name="close-blue" path="img" className={styles.avatarDelete} /> : null
              }
            </div>
          </Col>
        </Row>
        */ }

        <div className={styles.marginTop40}>
          <button onClick={this.toggleChangePassword} className={classNames(styles.grayButton1, styles.mobileBlock)}>
            Change your password
          </button>

          <button onClick={this.toggleDeleteAccount} type="button" className={classNames(styles.grayButton1, styles.mobileBlock, styles.deleteAccountButton)}>
            Delete your account
          </button>
        </div>

        <div className={styles.textCenter}>
          <button onClick={this.handleSubmit} type="button" className={classNames(styles.blueButton1, styles.mobileBlock, styles.saveProfileChangesButton)}>
            Save changes
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSettings);



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/ProfileSettings.js